import React from 'react';
import { Link } from 'react-router-dom';
import { Box, AppBar, Toolbar } from '@mui/material';
import Footer from '../Footer';

const AppContainer = ({ children }) => {
	return (
		<Box>
			<AppBar
				position='static'
				sx={{
					backgroundColor: 'unset',
					boxShadow: 'unset',
				}}
			>
				<Toolbar>
					<Link to='/'>
						<img
							style={{ width: '100px' }}
							src='images/app-logo.png'
							alt='img'
						/>
					</Link>
				</Toolbar>
			</AppBar>
			<Box>{children}</Box>
			<Footer />
		</Box>
	);
};

export default AppContainer;
